var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path27, _path28, _rect13, _rect14, _rect15, _rect16, _rect17, _path29, _path30, _path31, _path32, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCotatoCharacterBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 254,
    viewBox: "0 0 296 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8242 56.1309H139.183V64.125H148.869V212.054H139.183V212.144H138.579V220.293L49.6992 220.293V212.144H39.8242L39.8242 203.993H29.9493V64.2793H39.8242L39.8242 56.1309ZM20.0714 80.582H29.9463V179.546H20.0714V80.582ZM20.0703 109.688H10.1954V171.394H20.0703V109.688ZM168.243 196.063V171.075H178.44V131.094H168.243V111.104H158.048V80.1189H148.871V204.059H158.048V196.063H168.243ZM59.5713 220.293V228.443L128.7 228.443V220.293H59.5713Z",
    fill: "#D59F52"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 128.466,
    y: 108.225,
    width: 21.0215,
    height: 34.2572,
    fill: "#1A1918"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.507 31.1445H60.6646V39.2945H118.507V31.1445Z",
    fill: "#1A1918"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.383 228.05H59.2538V236.057H128.383V228.05Z",
    fill: "#1A1918"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9447 47.1368H39.7676V56.1325H49.3782L48.9447 47.1368Z",
    fill: "#1A1918"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.383 47.4444H138.258V56.1325H128.383V47.4444Z",
    fill: "#1A1918"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.507 39.2945H128.383V47.4444H118.507V39.2945Z",
    fill: "#1A1918"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9447 39.2945H60.6646V47.4444L48.9447 47.1368V39.2945Z",
    fill: "#1A1918"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7676 56.1325H29.6271V64.1287H39.7676V56.1325Z",
    fill: "#1A1918"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.258 56.1325H148.134V64.1287H138.258V56.1325Z",
    fill: "#1A1918"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6271 64.1287H19.7515V80.0442H29.6271V64.1287Z",
    fill: "#1A1918"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7515 80.0442H9.87589V109.151H19.7515V80.0442Z",
    fill: "#1A1918"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.134 64.1287H158.01V80.121H148.134V64.1287Z",
    fill: "#1A1918"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87589 109.151H0.000289917V170.858H9.87589V109.151Z",
    fill: "#1A1918"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.247 80.121H158.01V111.48H168.247V80.121Z",
    fill: "#1A1918"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6271 179.008H19.7515V203.062H29.6271V179.008Z",
    fill: "#1A1918"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M168.247 170.858H178.443V195.066H168.247V170.858Z",
    fill: "#1A1918"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.247 111.48H178.443V131.272H168.247V111.48Z",
    fill: "#1A1918"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5026 203.062H29.6271V211.607H39.5026V203.062Z",
    fill: "#1A1918"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7515 170.858H9.87589V179.008H19.7515V170.858Z",
    fill: "#1A1918"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.873 204.061H158.01V212.058H148.873V204.061Z",
    fill: "#1A1918"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M158.01 195.066H168.247V204.061H158.01V195.066Z",
    fill: "#1A1918"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9447 211.607H39.5026V220.054H48.9447V211.607Z",
    fill: "#1A1918"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M138.676 212.058H148.873V220.054H138.676V212.058Z",
    fill: "#1A1918"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2538 220.054H48.9447V228.05H59.2538V220.054Z",
    fill: "#1A1918"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.383 220.054H138.676V228.05H128.383V220.054Z",
    fill: "#1A1918"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M168.247 131.272H178.443V170.858H168.247V131.272Z",
    fill: "#1A1918"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9453,
    y: 106.666,
    width: 21.0215,
    height: 34.2572,
    fill: "#1A1918"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.0664,
    y: 114.451,
    width: 10.9,
    height: 14.0143,
    fill: "#F7F4F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 138.587,
    y: 114.451,
    width: 10.9,
    height: 14.0143,
    fill: "#F7F4F0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.78573,
    height: 9.34288,
    transform: "matrix(-1 0 0 1 89.5371 145.596)",
    fill: "#1A1918"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.00716,
    height: 8.5643,
    transform: "matrix(-1 0 0 1 124.573 146.373)",
    fill: "#1A1918"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 28.3894,
    height: 7.25954,
    transform: "matrix(-1 0 0 1 78.999 237.096)",
    fill: "#B17C31"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 24.4722,
    height: 6.99664,
    transform: "matrix(-1 0 0 1 141.735 237.045)",
    fill: "#B17C31"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 28.5509,
    height: 7.99615,
    transform: "matrix(-1 0 0 1 117.265 155.084)",
    fill: "#1A1918"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 28.5509,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 78.5156 228.051)",
    fill: "#1A1918"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 27.5312,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 78.5156 244.041)",
    fill: "#1A1918"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5115,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 143.775 244.041)",
    fill: "#1A1918"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.505 39.2949H60.6621V47.1368H48.94V56.1325H60.6673V63.7437H111.456V56.1325H128.475V47.1368H118.505V39.2949ZM95.9375 63.7441H60.6676V71.8941H95.9375V63.7441Z",
    fill: "#EBBA77"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7654 56.1309H48.9425V101.109H39.7654V56.1309ZM29.5664 64.127H39.7632V179.009H49.3721V187.155H77.5869V195.305H39.7632V195.307H87.4619V203.457H39.4948V203.06H29.5664V179.007H19.7451V80.043H29.5664V64.127ZM19.7441 109.15H9.86914V170.857H19.7441V109.15ZM97.34 203.457V211.055H128.475V203.061H138.67V195.065L158.044 195.065V204.061H148.868V212.057H138.671V220.051H48.9395V211.607H39.4973L39.4973 203.457H97.34ZM128.477 220.053V228.049H59.1387V220.053H128.477ZM168.241 195.065V187.068H138.671V195.065H168.241Z",
    fill: "#B17C31"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 8.1574,
    height: 24.988,
    transform: "matrix(-1 0 0 1 57.1016 228.051)",
    fill: "#1A1918"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 8.1574,
    height: 23.9885,
    transform: "matrix(-1 0 0 1 80.5557 229.051)",
    fill: "#1A1918"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 7.13772,
    height: 24.988,
    transform: "matrix(-1 0 0 1 143.775 228.051)",
    fill: "#1A1918"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 7.13772,
    height: 23.9885,
    transform: "matrix(-1 0 0 1 124.402 229.051)",
    fill: "#1A1918"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 26.5115,
    height: 8.99567,
    transform: "matrix(-1 0 0 1 143.775 228.051)",
    fill: "#1A1918"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.914 13.6465H42.5031V20.4699H103.914V13.6465ZM130.069 70.5089H92.5403V77.3314H8.38493V70.5089H8.38477V55.7248H134.618V70.508H148.264V77.3314H130.069V70.5089ZM127.795 40.9377H127.797V47.7611H15.2111V40.9377H22.0324V27.2932H28.8547V20.4709H120.971V27.2932H127.795V40.9377ZM134.621 47.7639H15.2111V55.7245H134.621V47.7639ZM173.284 77.3322H92.5402V84.1525H64.1122V77.3322H15.2111V84.1525V84.1556V90.976H35.6813V84.1556H64.1105V90.976H180.109V84.1525H173.284V77.3322ZM142.58 90.9768H49.3263V97.8002H142.58V90.9768ZM56.1506 97.801H135.757V104.624H128.933V111.447H62.9738V104.624H56.1506V97.801ZM78.8947 111.449H114.149V118.273H78.8947V111.449Z",
    fill: "#235DD1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0343 40.9414H15.2109V90.9797H22.0343V90.9786H28.8556V90.9769H35.6789V84.1535H64.1096V77.3301H35.6789H35.6787H28.8556V69.3711H22.0343V40.9414ZM8.38477 55.7246H15.2082V77.3321H8.38477V55.7246ZM157.362 97.8047H190.342V104.628H157.362V97.8047ZM49.3263 90.9807H69.7965V97.8041H49.3263V90.9807ZM76.6206 97.8047H56.1504V104.628H62.9734V111.45H78.8945V118.271H114.149V111.447H91.4043V104.627H76.6206V97.8047ZM122.11 104.627H128.933V111.45H122.11V104.627Z",
    fill: "#183A7E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.965 13.6465H97.083V20.4699H120.965V13.6465ZM109.596 20.4707H138.027V27.293H144.85V70.5079H120.968V70.5077H114.146V70.509H92.5381V63.6855H114.145V53.4492H120.968V27.2941H109.596V20.4707ZM92.5354 70.5078H81.1631V77.3312H92.5354V70.5078ZM131.202 90.9766H142.574V97.8H131.202V90.9766ZM135.751 97.8008H124.379V104.624H135.751V97.8008ZM144.85 47.7637H151.673V70.5084H144.85V47.7637ZM197.161 90.9758V84.1523H190.337V77.3318H152.808V84.1523H142.574V90.9758H197.161ZM176.69 77.3312V70.5078H158.495L158.495 77.3312H176.69Z",
    fill: "#3270ED"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.461 0H57.2851V6.82341H108.461V0ZM42.5009 6.82417H120.97V13.6462H138.027V20.4697H120.969V13.6476H42.5009V6.82417ZM28.8535 13.6464H42.5003V20.4698H28.8535V13.6464ZM28.8546 20.4707H22.0312V27.291H15.2079V40.9378H22.0314V27.2941H28.8546V20.4707ZM64.1085 90.9777H49.3243V97.7999H42.5009V90.9777H35.6782V97.7999H15.2079V90.9774H8.38568V76.1933H15.2091V90.9765H35.6777V84.1543H64.1085V90.9777ZM49.3251 97.8027H56.1485V104.626H49.3251V97.8027ZM135.756 97.8027H142.579V104.626H135.756V97.8027ZM157.362 97.8027H150.539V104.626H157.362V97.8027ZM62.9718 104.629H56.1484V111.452H62.9695V118.274H78.8908V111.451H62.9718V104.629ZM135.752 104.629H128.928V111.451H114.148V118.274H130.07V111.452H135.752V104.629ZM197.164 90.9765H142.579V97.7999H203.99V90.9765H203.987V84.1543H197.164V90.9765ZM78.8925 118.271H114.147V125.095H78.8925V118.271ZM144.849 20.4707H138.025V27.2941H144.849V20.4707ZM176.692 77.3312H190.338V84.1533H197.161V77.3299H190.339V70.5078H176.697V63.6855H158.501V70.5089H176.692V77.3312ZM190.338 97.8027H197.161V104.626H190.338V97.8027ZM190.342 104.629H157.362V111.452H190.342V104.629ZM158.499 77.3312H92.54V84.1533H64.1091V77.3299H92.539V70.5078H151.675V47.7637H158.498V70.5078H158.499V77.3312ZM8.38568 40.9394H15.2091V55.7235H8.38568V40.9394ZM8.38298 55.7246H1.55957V77.3321H8.38298V55.7246ZM151.676 27.291H144.852V47.7612H151.676V27.291Z",
    fill: "#1A1918"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 149.487,
    y: 98.0996,
    width: 10.1214,
    height: 22.5786,
    fill: "#D59F52"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 175.96,
    y: 131.578,
    width: 13.2357,
    height: 45.9358,
    fill: "#1A1918"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 159.609,
    y: 98.0996,
    width: 8.5643,
    height: 22.5786,
    fill: "#1A1918"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 168.173,
    y: 131.578,
    width: 10.1214,
    height: 45.9358,
    fill: "#D59F52"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 213.101,
    y: 73.1875,
    width: 4.44352,
    height: 4.44352,
    transform: "rotate(45 213.101 73.1875)",
    fill: "#70AD51"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 4.44352,
    height: 4.44352,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 224.029 192.309)",
    fill: "#70AD51"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 227.666,
    y: 73.1875,
    width: 8.48651,
    height: 8.48651,
    transform: "rotate(45 227.666 73.1875)",
    fill: "#70AD51"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 8.48651,
    height: 8.48651,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 213.101 193.088)",
    fill: "#70AD51"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 16.3585,
    height: 16.3585,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 244.91 200.094)",
    fill: "#70AD51"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7363,
    y: 26.4746,
    width: 15.5715,
    height: 5.45001,
    fill: "#D9D9D9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3076,
    y: 31.9258,
    width: 5.45001,
    height: 5.45001,
    fill: "#D9D9D9"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3076,
    y: 42.8242,
    width: 5.45001,
    height: 10.1214,
    fill: "#D9D9D9"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7363,
    y: 37.373,
    width: 15.5715,
    height: 5.45001,
    fill: "#D9D9D9"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7363,
    y: 52.9453,
    width: 15.5715,
    height: 5.45001,
    fill: "#D9D9D9"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2871,
    y: 31.9258,
    width: 5.45001,
    height: 26.4715,
    fill: "#D9D9D9"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 213.222,
    y: 108.064,
    width: 63.3981,
    height: 63.3981,
    fill: "#70AD51"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 220.655,
    y: 101.943,
    width: 48.5323,
    height: 75.6405,
    fill: "#70AD51"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 207.102,
    y: 113.312,
    width: 75.6405,
    height: 52.9046,
    fill: "#70AD51"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 219.781,
    y: 137.797,
    width: 5.68397,
    height: 17.4891,
    fill: "#F7F4F0"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 225.466,
    y: 132.549,
    width: 40.6622,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 225.466,
    y: 138.234,
    width: 34.9783,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 225.466,
    y: 143.916,
    width: 24.922,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 225.466,
    y: 149.602,
    width: 19.238,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 261.754,
    y: 121.184,
    width: 5.68397,
    height: 11.3679,
    fill: "#F7F4F0"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 267.439,
    y: 115.498,
    width: 5.68397,
    height: 17.0519,
    fill: "#F7F4F0"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 273.124,
    y: 152.223,
    width: 5.68397,
    height: 8.74456,
    fill: "#F7F4F0"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 260.443,
    y: 160.969,
    width: 12.6796,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 278.807,
    y: 143.916,
    width: 5.68397,
    height: 8.30733,
    fill: "#F7F4F0"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 278.807,
    y: 109.375,
    width: 5.68397,
    height: 34.541,
    fill: "#F7F4F0"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 284.49,
    y: 120.744,
    width: 5.68397,
    height: 23.1731,
    fill: "#F7F4F0"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 273.124,
    y: 104.129,
    width: 5.68397,
    height: 34.1038,
    fill: "#F7F4F0"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 231.149,
    y: 126.865,
    width: 30.606,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 225.466,
    y: 155.285,
    width: 19.238,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 244.703,
    y: 149.602,
    width: 5.68397,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 219.781,
    y: 163.592,
    width: 5.68397,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 250.388,
    y: 143.916,
    width: 10.0562,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 260.443,
    y: 138.234,
    width: 5.68397,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 266.127,
    y: 132.549,
    width: 6.99565,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 271.812,
    y: 138.234,
    width: 6.99565,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 266.127,
    y: 143.916,
    width: 12.6796,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 260.443,
    y: 149.602,
    width: 18.3636,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 248.2,
    y: 160.969,
    width: 6.99565,
    height: 5.68397,
    fill: "#F7F4F0"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 254.76,
    y: 155.285,
    width: 18.3636,
    height: 11.3679,
    fill: "#F7F4F0"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 278.808,
    y: 104.131,
    width: 5.68397,
    height: 5.24674,
    fill: "#70AD51"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 284.492,
    y: 109.377,
    width: 5.68397,
    height: 11.3679,
    fill: "#70AD51"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 290.176,
    y: 120.744,
    width: 5.68397,
    height: 23.1731,
    fill: "#70AD51"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 284.492,
    y: 143.916,
    width: 5.68397,
    height: 8.30733,
    fill: "#70AD51"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 278.808,
    y: 152.223,
    width: 5.68397,
    height: 8.74456,
    fill: "#70AD51"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 273.124,
    y: 98.8828,
    width: 5.68397,
    height: 5.24674,
    fill: "#70AD51"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 267.439,
    y: 104.131,
    width: 5.68397,
    height: 5.24674,
    fill: "#70AD51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotatoCharacterBack);
export default __webpack_public_path__ + "static/media/cotato_character_back.e1ec2613d8ff048d627047303a817f3e.svg";
export { ForwardRef as ReactComponent };